import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './features/login/login.component';
import { ClientsComponent } from './features/clients/clients.component';
import { BannersComponent } from './features/banners/banners.component';
import { AuditComponent } from './features/audit/audit.component';
import { authGuard } from './core/guards/auth.guard';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'clients', component: ClientsComponent, canActivate: [authGuard] },
  { path: 'clients/:clientId/banners', component: BannersComponent, canActivate: [authGuard] },
  { path: 'banners/:bannerId/audit', component: AuditComponent, canActivate: [authGuard] },
  { path: '', redirectTo: '/clients', pathMatch: 'full' },
  { path: '**', redirectTo: '/clients' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
